export const floorFragment = `
  id
  name
  imageUrl
  size
  bedrooms
  bathrooms
  isBelowGrade
  floorGroups {
    id
    name
    enableMultipleSelection
    floorOptions {
      id
      name
      imageUrl
      priceChange
      sizeChange
      bedsChange
      bathsChange
      garagesChange
      description
      alternateImageUrl
      alternateOption
      isDefault
      imagesCount
      priceRulesCount
      lotWorksSettings
      dependenciesLogicalOperator
      availabilityRule
      availabilityCommunities
      availabilityCommunityPhases
      defaultCommunities
      externalId
      dependencies {
        floor
        group
        operator
        values
      }
      isAutoSelectedByDefault
      applyFloorPlanHighlight
    }
  }
`;

export const listFloorsQuery = `
  query ListFloors(
    $filter: FloorFilterInput
  ) {
    items: listFloors(filter: $filter) {
      ${floorFragment}
    }
  }
`;

export const createFloorMutation = `
  mutation CreateFloor(
    $input: CreateFloorInput!
    $image: Upload
  ) {
    item: createFloor(input: $input, image: $image) {
      ${floorFragment}
    }
  }
`;

export const updateFloorMutation = `
  mutation UpdateFloor(
    $input: UpdateFloorInput!
    $image: Upload
  ) {
    item: updateFloor(input: $input, image: $image) {
      ${floorFragment}
    }
  }
`;

export const deleteFloorQuery = `
  mutation DeleteFloor(
    $id: Int!
  ) {
    item: deleteFloor(id: $id) {
      ${floorFragment}
    }
  }
`;

export const sortFloorsQuery = `
  mutation SortFloors(
    $ids: [Int!]!
  ) {
    items: sortFloors(ids: $ids) {
      ${floorFragment}
    }
  }
`;
